import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

export type ConfirmNoDirectorOfficerVariant = "director" | "officer" | "both";

const CONTENT: Record<
  ConfirmNoDirectorOfficerVariant,
  { title: string; description: string }
> = {
  director: {
    title: "Confirm no directors have been appointed?",
    description: "Marking this confirms that the entity has no directors.",
  },
  officer: {
    title: "Confirm no officers have been appointed?",
    description: "Marking this confirms that the entity has no officers.",
  },
  both: {
    title: "Confirm no directors and officers have been appointed?",
    description:
      "Marking this confirms that the entity has no officers and directors.",
  },
};

export const ConfirmNoDirectorOfficerModal = ({
  open,
  onClose,
  onConfirm,
  variant = "both",
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: ConfirmNoDirectorOfficerVariant;
}) => {
  const { title, description } = CONTENT[variant];

  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size="small">
        <StatusModal type="warning" title={title}>
          {description}{" "}
          <span className="t-font-bold">
            This may affect your federal filings.
          </span>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button type="button">Go back</Button>
          </Modal.RawClose>
          <Button customType="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
